module.exports = __webpack_public_path__ + "img/fwsjmbanner.f72ce7f4.svg";